import {
  Input,
  OnChanges,
  SimpleChanges,
  Directive,
  Output,
  EventEmitter,
} from "@angular/core";

@Directive()
export class GenericTableAnagraphAnagraph {
  @Input("CurrentObject") CurrentObject: any = null;

  public OnChanges(): void {}
}
